import servicesUtils from "../../../utils/servicesUtils";

/** Query params for GET .../reminder/{id}/notes/ — cursor pagination & sorting */

var getReminderNotes = function getReminderNotes(patientUid, reminderId) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return servicesUtils.getService("/patients/".concat(patientUid, "/reminder/").concat(reminderId, "/notes/"), params);
};
export default getReminderNotes;